<template>
  <nx-bform-group class="bd-black" :label="name" v-bind="$attrs">
    <legend style="display: none;"></legend>
    <nx-bform-input
      :name="name"
      :rules="{ required }"
      :value="$attrs.value"
      @input="$listeners.input"
      :aria-label="name"
    />
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("loginName");
    }
  }
};
</script>

<i18n src="@/locales/login.locale.json" />
